"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var _core = require("core.ui-module_site-components");
var _Saml = require("../../api/authn/Saml");
var _ApplicationContext = require("../../api/ApplicationContext");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const relayStateRef = /*#__PURE__*/_react.default.createRef();
const assertionRef = /*#__PURE__*/_react.default.createRef();
const formRef = /*#__PURE__*/_react.default.createRef();
class SamlLaunch extends _react.default.Component {
  constructor(props) {
    super(props);
    this.state = {
      showError: false
    };
  }
  componentDidMount() {
    const providerId = _ApplicationContext.ApplicationContext.getContext('samllaunch.providerId');
    (0, _Saml.getSamlToken)(providerId).then(response => {
      assertionRef.current.name = response.data.assertionParameterName;
      assertionRef.current.value = response.data.assertion;
      relayStateRef.current.value = response.data.relayState;
      formRef.current.action = response.data.providerUrl;
      if (!response.data.providerUrl) {
        this.setState({
          showError: true
        });
      } else {
        formRef.current.submit();
      }
    }).catch(() => {
      window.close();
      this.setState({
        showError: true
      });
    });
  }
  render() {
    const title = _ApplicationContext.ApplicationContext.getContext('samllaunch.title');
    const {
      showError
    } = this.state;
    return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, !showError ? /*#__PURE__*/_react.default.createElement("div", {
      className: "has-text-centered"
    }, /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("h1", {
      className: "title is-3"
    }, "Please wait while we are launching ", /*#__PURE__*/_react.default.createElement("span", {
      id: "title"
    }, title)), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement(_core.Spinner, null), /*#__PURE__*/_react.default.createElement("form", {
      ref: formRef,
      method: "post",
      target: "samlpopup"
    }, /*#__PURE__*/_react.default.createElement("input", {
      ref: relayStateRef,
      type: "hidden",
      name: "RelayState",
      value: ""
    }), /*#__PURE__*/_react.default.createElement("input", {
      ref: assertionRef,
      type: "hidden",
      name: "assertion",
      value: ""
    }))) : /*#__PURE__*/_react.default.createElement("div", {
      className: "has-text-centered"
    }, /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("p", null, "Currently unavailable. Please try again later.")));
  }
}
var _default = exports.default = (0, _reactRouterDom.withRouter)(SamlLaunch);
//# sourceMappingURL=SamlLaunch.js.map